// @ts-nocheck
import { Box, Card, Code, Divider, Flex, Grid, Group, Stack, Text, Title } from '@/components/ui';

export default function LayoutPage() {
  return (
    <Stack gap="xl">
      <Stack gap="xs">
        <Title order={2}>Layout Components</Title>
        <Text c="dimmed" size="sm">
          Components for arranging and positioning other components - Grid, Flex, Stack, and Group
        </Text>
      </Stack>

      {/* Stack */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Stack gap="xs">
            <Title order={4}>Stack</Title>
            <Text size="sm" c="dimmed">
              Arrange children vertically with consistent spacing
            </Text>
          </Stack>

          <Stack gap="sm">
            <Text size="sm" fw={500}>Example:</Text>
            <Card withBorder p="md" style={{ background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))' }}>
              <Stack gap="sm">
                <Box p="sm" style={{ background: 'var(--mantine-color-blue-light)' }}>
                  Item 1
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-blue-light)' }}>
                  Item 2
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-blue-light)' }}>
                  Item 3
                </Box>
              </Stack>
            </Card>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Stack gap="sm">
  <Box>Item 1</Box>
  <Box>Item 2</Box>
  <Box>Item 3</Box>
</Stack>`}
            </Code>
          </Stack>
        </Stack>
      </Card>

      {/* Group */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Stack gap="xs">
            <Title order={4}>Group</Title>
            <Text size="sm" c="dimmed">
              Arrange children horizontally with consistent spacing
            </Text>
          </Stack>

          <Stack gap="sm">
            <Text size="sm" fw={500}>Example:</Text>
            <Card withBorder p="md" style={{ background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))' }}>
              <Group gap="sm">
                <Box p="sm" style={{ background: 'var(--mantine-color-green-light)' }}>
                  Item 1
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-green-light)' }}>
                  Item 2
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-green-light)' }}>
                  Item 3
                </Box>
              </Group>
            </Card>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Group gap="sm">
  <Box>Item 1</Box>
  <Box>Item 2</Box>
  <Box>Item 3</Box>
</Group>`}
            </Code>
          </Stack>

          <Divider />

          <Stack gap="sm">
            <Text size="sm" fw={500}>With Justify:</Text>
            <Card withBorder p="md" style={{ background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))' }}>
              <Group justify="space-between">
                <Box p="sm" style={{ background: 'var(--mantine-color-green-light)' }}>
                  Left
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-green-light)' }}>
                  Right
                </Box>
              </Group>
            </Card>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Group justify="space-between">
  <Box>Left</Box>
  <Box>Right</Box>
</Group>`}
            </Code>
          </Stack>
        </Stack>
      </Card>

      {/* Grid */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Stack gap="xs">
            <Title order={4}>Grid</Title>
            <Text size="sm" c="dimmed">
              Responsive grid layout with 12-column system
            </Text>
          </Stack>

          <Stack gap="sm">
            <Text size="sm" fw={500}>Basic Grid:</Text>
            <Grid>
              <Grid.Col span={4}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  span=4
                </Card>
              </Grid.Col>
              <Grid.Col span={4}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  span=4
                </Card>
              </Grid.Col>
              <Grid.Col span={4}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  span=4
                </Card>
              </Grid.Col>
              <Grid.Col span={6}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  span=6
                </Card>
              </Grid.Col>
              <Grid.Col span={6}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  span=6
                </Card>
              </Grid.Col>
            </Grid>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Grid>
  <Grid.Col span={4}>Column 1</Grid.Col>
  <Grid.Col span={4}>Column 2</Grid.Col>
  <Grid.Col span={4}>Column 3</Grid.Col>
  <Grid.Col span={6}>Column 4</Grid.Col>
  <Grid.Col span={6}>Column 5</Grid.Col>
</Grid>`}
            </Code>
          </Stack>

          <Divider />

          <Stack gap="sm">
            <Text size="sm" fw={500}>Responsive Grid:</Text>
            <Grid>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  Responsive
                </Card>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  Responsive
                </Card>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  Responsive
                </Card>
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
                <Card withBorder p="md" style={{ background: 'var(--mantine-color-violet-light)' }}>
                  Responsive
                </Card>
              </Grid.Col>
            </Grid>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Grid>
  <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
    Column 1
  </Grid.Col>
  <Grid.Col span={{ base: 12, md: 6, lg: 3 }}>
    Column 2
  </Grid.Col>
  {/* ... more columns */}
</Grid>`}
            </Code>
          </Stack>
        </Stack>
      </Card>

      {/* Flex */}
      <Card withBorder p="lg">
        <Stack gap="md">
          <Stack gap="xs">
            <Title order={4}>Flex</Title>
            <Text size="sm" c="dimmed">
              Flexbox container for flexible layouts
            </Text>
          </Stack>

          <Stack gap="sm">
            <Text size="sm" fw={500}>Horizontal Flex:</Text>
            <Card withBorder p="md" style={{ background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))' }}>
              <Flex gap="md">
                <Box p="sm" style={{ background: 'var(--mantine-color-orange-light)' }}>
                  Item 1
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-orange-light)' }}>
                  Item 2
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-orange-light)' }}>
                  Item 3
                </Box>
              </Flex>
            </Card>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Flex gap="md">
  <Box>Item 1</Box>
  <Box>Item 2</Box>
  <Box>Item 3</Box>
</Flex>`}
            </Code>
          </Stack>

          <Divider />

          <Stack gap="sm">
            <Text size="sm" fw={500}>With Justify and Align:</Text>
            <Card withBorder p="md" style={{ background: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6))' }}>
              <Flex gap="md" justify="center" align="center" style={{ minHeight: 100 }}>
                <Box p="sm" style={{ background: 'var(--mantine-color-orange-light)' }}>
                  Centered
                </Box>
                <Box p="sm" style={{ background: 'var(--mantine-color-orange-light)' }}>
                  Content
                </Box>
              </Flex>
            </Card>
          </Stack>

          <Stack gap="xs">
            <Text size="sm" fw={500}>Code:</Text>
            <Code block language="tsx">
{`<Flex gap="md" justify="center" align="center">
  <Box>Centered</Box>
  <Box>Content</Box>
</Flex>`}
            </Code>
          </Stack>
        </Stack>
      </Card>
    </Stack>
  );
}
